import {
  Box,
  Flex,
  Text,
  Modal,
  ModalContent,
  ModalOverlay,
  Image,
} from "@chakra-ui/react";
import React, { memo, useEffect } from "react";
import IconX from "../../../assets/images/booking/x-circle.svg";
import toast from "react-hot-toast";

const FormInfo = memo(({ isOpen, onClose, defaultValues, refetch }) => {
  useEffect(() => {}, [isOpen]);

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        backgroundColor="var(--color-main)"
        borderRadius={"16px"}
        position={"relative"}
        w={"100%"}
        maxW={"1025px"}
      >
        <Box
          paddingBottom={"80px"}
          h={"86.5vh"}
          w={"100%"}
          overflowY={"scroll"}
          sx={{
            "&::-webkit-scrollbar": {
              width: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              width: "4px",
              borderRadius: "50px",
              background: "var(--color-background)",
            },
            "&::-moz-scrollbar": {
              width: "4px",
            },
            "&::-moz-scrollbar-thumb": {
              width: "4px",
              borderRadius: "50px",
              background: "var(--color-background)",
            },
          }}
        >
          <Flex
            alignItems={"center"}
            p={"25px 24px 24px 24px"}
            position={"relative"}
            borderBottom={
              defaultValues?.status === "APPROVED" ||
              defaultValues?.status === "REJECTED"
                ? ""
                : "1px solid var(--border-input-employee)"
            }
          >
            <Text
              color={"var(--color-header-employee)"}
              fontSize={"16px"}
              fontWeight={"600"}
            >
              Chi tiết
            </Text>
            <Box
              position={"absolute"}
              top={"24px"}
              right={"24px"}
              cursor={"pointer"}
              onClick={onClose}
            >
              <Image src={IconX} />
            </Box>
          </Flex>
          <Box margin={"0 auto"} p={"24px 40px"}>
            <Box>
              <Flex gap={"16px"} flex={1} mb={"16px"}>
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  Mã nhân viên:
                </Text>
                <Text color={"var(--color-header-employee)"} fontSize={"16px"}>
                  {defaultValues?.codeEmployee || "-"}
                </Text>
              </Flex>
              <Flex gap={"16px"} flex={1} mb={"16px"}>
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  Tên nhân viên:
                </Text>
                <Text color={"var(--color-header-employee)"} fontSize={"16px"}>
                  {defaultValues?.nameEmployee || "-"}
                </Text>
              </Flex>
              <Flex gap={"16px"} flex={1} mb={"16px"}>
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  Loại:
                </Text>
                <Text color={"var(--color-header-employee)"} fontSize={"16px"}>
                  {defaultValues?.type || "-"}
                </Text>
              </Flex>
              <Flex gap={"16px"} flex={1} mb={"16px"}>
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  Hành động:
                </Text>
                <Text color={"var(--color-header-employee)"} fontSize={"16px"}>
                  {defaultValues?.action || "-"}
                </Text>
              </Flex>
              <Flex gap={"16px"} flex={1} mb={"16px"}>
                <Text
                  color={"var(--color-header-employee)"}
                  fontSize={"16px"}
                  fontWeight={"600"}
                >
                  Thời gian tạo:
                </Text>
                <Text color={"var(--color-header-employee)"} fontSize={"16px"}>
                  {defaultValues?.createdAt || "-"}
                </Text>
              </Flex>

              <Flex gap={"24px"}>
                <Box flex={1}>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Dữ liệu cũ
                  </Text>
                  <Box
                    background={"var(--fill-avatar)"}
                    p={"16px 24px 16px 16px"}
                    mt={"16px"}
                    borderRadius={"8px"}
                  >
                    {renderKeyValueBox(defaultValues?.oldValue)}
                  </Box>
                </Box>
                <Box flex={1}>
                  <Text
                    color={"var(--color-header-employee)"}
                    fontSize={"16px"}
                    fontWeight={"600"}
                  >
                    Dữ liệu mới
                  </Text>
                  <Box
                    background={"var(--fill-avatar)"}
                    p={"16px 24px 16px 16px"}
                    mt={"16px"}
                    borderRadius={"8px"}
                  >
                    {renderKeyValueBox(defaultValues?.newValue)}
                  </Box>
                </Box>
              </Flex>
            </Box>
          </Box>
        </Box>
      </ModalContent>
    </Modal>
  );
});

const formatValue = (value) => {
  if (typeof value === "boolean") return value ? "true" : "false";
  if (value === null || value === undefined) return "-";
  if (typeof value === "object") return "[Object]";
  return value.toString();
};

const flattenObjectWithLevel = (obj, prefix = "", level = 1) => {
  return Object.entries(obj || {}).reduce((acc, [key, value]) => {
    const fullKey = prefix ? `${prefix}.${key}` : key;

    if (value && typeof value === "object" && !Array.isArray(value)) {
      acc.push(...flattenObjectWithLevel(value, fullKey, level + 1));
    } else {
      acc.push({ key: fullKey, value, level });
    }

    return acc;
  }, []);
};

const renderKeyValueBox = (data) => {
  if (!data || typeof data !== "object") return null;

  const flattened = flattenObjectWithLevel(data);

  let currentGroup = "";
  return flattened.map(({ key, value, level }, index) => {
    const keyParts = key.split(".");
    const topKey = keyParts[0];

    // Nếu là cấp 1 → hiển thị bình thường
    if (level === 1) {
      return (
        <Flex key={key} alignItems={"center"} mb="8px" gap="12px">
          <Text fontWeight="700" mt="0px" mb="0px" color="gray.900">
            {key}:
          </Text>
          <Text flex="1" color="gray.800">
            {formatValue(value)}
          </Text>
        </Flex>
      );
    }

    // Cấp 2 trở lên → nhóm theo parent
    const isNewGroup = topKey !== currentGroup;
    if (isNewGroup) currentGroup = topKey;

    return (
      <Box key={key}>
        {isNewGroup && (
          <Text fontWeight="700" mt="12px" mb="4px" color="gray.900">
            {topKey}:
          </Text>
        )}
        <Flex mb="8px" gap="12px" ml={getMargin(level)}>
          <Text minW="180px" fontWeight="500" color="gray.600">
            {keyParts.slice(1).join(".")}:
          </Text>
          <Text flex="1" color="gray.800">
            {formatValue(value)}
          </Text>
        </Flex>
      </Box>
    );
  });
};

const getMargin = (level) => {
  switch (level) {
    case 2:
      return "16px";
    case 3:
      return "24px";
    default:
      return "0px";
  }
};

export default FormInfo;
